export const gnistaPrimaryColors = {
  main: "#8b9c8e",
  mainText: "#000000",
  secondaryText: "#ffffff",
  stepperText: "#ffffff",
  buttonText: "#ffffff",
  icon: "#bd9279",
  iconBg: "#2b6777",
  background: "#f2ece1",
  additionalInfo: "#018786",
  totalPrice: "#00384a",
  button: "#00384a",
  addButton: "#687b69",
  decButton: "#00384a",
  qtyBackground: "#ffffff",
  cartIconEmpty: "#bd9279",
  cartIconFilled: "#687b69",
  cartIconBackground: "#f2ece1",
  cartBadge: "#b30000",
  cartBackground: "#ffffff",
  cartBorders: "#687b69",
  dateRangeBgFrom: "#00384a",
  dateRangeBgTo: "#bd9279",
  dateRangeBgComplete: "#687b69",
  dateRangeTitle: "#ffffff",
  dateRangeBg: "#d2ccc5",
  providerSelectBg: "#d2ccc5",
  divider: "#687b69",
  productCardBg: "transparent",
  dialogBackground: "#f2ece1",
  skeletonBg: "#1d1d1d",
  skeletonContent: "#ffffff",
  filterSelected: "#f1d7ab",
  filterOption: "#bd9279",
  extraFields: "#808080",
  rescheduleAlert: "#c8d5e4",
};

export const gnistaSecondaryColors = {
  main: "#687b69",
  stepper: "#f2ece1",
  stepperText: "#000000",
  stepperIndicatorText: "#ffffff",
  background: "#d2ccc5",
  filterBackground: "#292929",
  text: "#bd9279",
};

export const scandiaPrimaryColors = {
  addButton: "#148e2a",
  additionalInfo: "#148e2a",
  background: "#ffffff",
  button: "#2c3070",
  buttonText: "#ffffff",
  cartBackground: "#ffffff",
  cartBadge: "#b30000",
  cartBorders: "#012659",
  cartIconBackground: "#ffffff",
  cartIconEmpty: "#012659",
  cartIconFilled: "#528d36",
  dateRangeBg: "#ffffff",
  dateRangeBgComplete: "#148e2a",
  dateRangeBgFrom: "#0454c2",
  dateRangeBgTo: "#012659",
  dateRangeTitle: "#000000",
  decButton: "#2c3070",
  dialogBackground: "#ffffff",
  divider: "#ffffff",
  extraFields: "#808080",
  filterOption: "#808080",
  filterSelected: "#012659",
  icon: "#012659",
  iconBg: "#2b6777",
  main: "#1A5396",
  mainText: "#000000",
  mobileStepper: "#ffffff",
  mobileStepperProgress: "#ffffff",
  noImageIcon: "#1A5396",
  productCardBg: "transparent",
  providerSelectBg: "#ffffff",
  qtyBackground: "#F4F4F4",
  rescheduleAlert: "#c8d5e4",
  reservedButtonColor: "#528d36",
  secondaryText: "#ffffff",
  serviceProviderBg: "#ffffff",
  stepperActiveText: "#1A5396",
  stepperActiveValue: "#ffffff",
  stepperBg: "#1A5396",
  stepperBgActive: "#FAFAFA",
  stepperCompleted: "#ffffff",
  stepperInactiveAvatar: "#ffffff",
  stepperInactiveText: "#ffffff",
  stepperInactiveValue: "#1A5396",
  stepperText: "#ffffff",
  totalPrice: "#012659",
};

export const scandiaSecondaryColors = {
  main: "#528d36",
  reservedButtonColor: "#528d36",
  stepper: "#1A5396",
  stepperText: "#000000",
  stepperIndicatorText: "#ffffff",
  // filters, sorting
  background: "#ffffff",
  filterBackground: "#292929",
  text: "#808080",
  serviceProviderBg: "transparent",
};
